import { Auth } from "aws-amplify";
import { S3Image } from "aws-amplify-react";
import classNames from "classnames";
import { preInterestColor } from "components/Leasing/constrant/leasing.ct";
import { prePrincipleColor } from "components/Leasing/constrant/leasing.ct";
import { preOverflow } from "components/Leasing/constrant/leasing.ct";
import { preLateColor } from "components/Leasing/constrant/leasing.ct";
import { ReversePaymentContext } from "components/Leasing/context/leasing.ctx.reversePayment";
import { getFilterInstallments } from "components/Leasing/utils/leasing.u";
import { format } from "date-fns";
import moment from "moment";
import numeral from "numeral";
import React, { Fragment, useContext } from "react";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import API from "../api/api.main";
import { Dialog, Transition } from "@headlessui/react";

const FootageEvidences = ({
  item,
  index,
  loan,
  setInstallments,
  setLoan,
  setLoading,
  setDate,
  refetch,
  date,
  env = "sandbox",
}) => {
  const {
    openReverse,
    currentEvidenceIndex,
    setCurrentEvidenceIndex,
    evidence,
    setEvidence,
    setLoadingCal,
  } = useContext(ReversePaymentContext);
  const [openDetail, setOpenDetail] = React.useState(false);

  const onClickSelectEvidence = async () => {
    let checkExist = false;
    setLoadingCal(true);
    if (item?.tx === evidence?.tx) {
      setEvidence("");
      setCurrentEvidenceIndex(-1);
      checkExist = true;
    } else {
      setEvidence(item);
      setCurrentEvidenceIndex(index);
    }
    try {
      setLoading(true);

      if (checkExist) {
        return await refetch(true, date);
      }
      const data = await API.post(
        "MoneyHubAdmin",
        env === "sandbox"
          ? `/leasing/loanSandbox/recal/${loan.loan_id}`
          : `/leasing/recal/${loan.loan_id}`,
        {
          body: {
            ...item,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setInstallments(getFilterInstallments(data?.installments));
      setLoan({
        ...data.leasing,
        ori_installments: data?.ori_installments,
        cloneLeasing: data?.cloneLeasing,
      });
      // setDate(getCurrentLocalDateTime(data.leasing.paidDateLatest).fullDate);
    } catch (error) {
      console.log("recal error", error);
    } finally {
      setLoading(false);
      setLoadingCal(false);
    }
  };

  const getConditionEvidence = () => {
    if (openReverse) {
      if (index < currentEvidenceIndex) {
        return true;
      }
    }
    return false;
  };

  const onClickOpenEvidenceDetail = () => {
    setOpenDetail(!openDetail);
  };

  const handleApprove = useFullScreenHandle();

  return (
    <div
      className={classNames(
        "relative bg-white  overflow-hidden p-2 w-72 flex-shrink-0",
        {
          " opacity-20": getConditionEvidence(),
        }
      )}
    >
      <Transition appear show={openDetail} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={() => onClickOpenEvidenceDetail(false)}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-50"
              leave="ease-in duration-200"
              leaveFrom="opacity-50"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="border border-gray-200 z-50 inline-block w-10/12 mt-20 p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="grid grid-cols-3 gap-1">
                  {item.evidences.map((evidence, index) => {
                    return (
                      <div
                        key={index}
                        className="border border-gray-500 p-2 text-xs"
                      >
                        <div className="flex">
                          <div>งวดที่ {evidence.period} </div>
                          <div className="flex">
                            <div className=" ml-1">(</div>
                            <div className="text-pink-500">
                              {numeral(evidence.totalPeriod).format("0,000.00")}
                            </div>
                            <div>,&nbsp;</div>
                            <div
                              className={classNames({
                                [prePrincipleColor]: [
                                  "ชำระเลท",
                                  "ชำระปกติ",
                                ].includes(evidence.evidenceDisplayStatus),
                                [preOverflow]:
                                  evidence.evidenceDisplayStatus ===
                                  "ชำระล่วงหน้า",
                              })}
                            >
                              {["ชำระเลท", "ชำระปกติ"].includes(
                                evidence?.evidenceDisplayStatus
                              )
                                ? "ชำระประจำงวด"
                                : evidence?.evidenceDisplayStatus}
                            </div>
                            <div> )</div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2">
                          <div
                            className={classNames(
                              "flex space-x-2",
                              prePrincipleColor
                            )}
                          >
                            <div>(เงินต้น)</div>
                            <div>
                              {" "}
                              {numeral(
                                evidence?.evidencePaidPrinciplePeriod
                              ).format("0,000.00")}
                            </div>
                          </div>
                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                prePrincipleColor
                              )}
                            >
                              (ภาษี):{" "}
                              {numeral(
                                evidence.evidencePaidPrincipleVatPeriod
                              ).format("0,000.00")}
                            </div>
                          )}
                          <div
                            className={classNames(
                              "flex space-x-2",
                              preOverflow
                            )}
                          >
                            (ล่วงหน้า):{" "}
                            {numeral(
                              evidence.evidencePaidPrincipleOverflowPeriod
                            ).format("0,000.00")}
                          </div>
                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                preOverflow
                              )}
                            >
                              (ภาษี):{" "}
                              {numeral(
                                evidence.evidencePaidPrincipleVatOverflowPeriod
                              ).format("0,000.00")}
                            </div>
                          )}

                          <div
                            className={classNames(
                              "flex space-x-2",
                              preInterestColor
                            )}
                          >
                            (ดอกเบี้ย):{" "}
                            {numeral(
                              evidence.evidencePaidInterestPeriod
                            ).format("0,000.00")}
                          </div>
                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                preInterestColor
                              )}
                            >
                              (ภาษี):{" "}
                              {numeral(
                                evidence.evidencePaidInterestVatPeriod
                              ).format("0,000.00")}
                            </div>
                          )}
                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                preOverflow
                              )}
                            >
                              (ล่วงหน้า):{" "}
                              {numeral(
                                evidence.evidencePaidInterestOverflowPeriod
                              ).format("0,000.00")}
                            </div>
                          )}

                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                preOverflow
                              )}
                            >
                              (ภาษี):{" "}
                              {numeral(
                                evidence.evidencePaidInterestVatOverflowPeriod
                              ).format("0,000.00")}
                            </div>
                          )}

                          <div
                            className={classNames(
                              "flex space-x-2",
                              preLateColor
                            )}
                          >
                            (ผิดนัด):{" "}
                            {numeral(evidence.evidencePaidPenaltyPeriod).format(
                              "0,000.00"
                            )}
                          </div>
                          <div
                            className={classNames(
                              "flex space-x-2",
                              preLateColor
                            )}
                          >
                            (ท่วงถาม):{" "}
                            {numeral(
                              evidence.evidencePaidDemandFeePeriod
                            ).format("0,000.00")}
                          </div>
                          {loan?.category === "TF" && (
                            <div
                              className={classNames(
                                "flex space-x-2",
                                preLateColor
                              )}
                            >
                              (ลงพื้นที่):{" "}
                              {numeral(
                                evidence.evidencePaidVisitFeePeriod
                              ).format("0,000.00")}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
      <div className="flex flex-row w-full">
        {item?.bill_img ? (
          <div className="h-12 mr-1 flex items-center">
            <FullScreen className="w-full h-full" handle={handleApprove}>
              <S3Image
                onClick={handleApprove.enter}
                className="w-full h-14 object-contain bg-black"
                imgKey={item?.bill_img}
              />
            </FullScreen>
          </div>
        ) : (
          <img className="h-12 mr-1" src={"/logo/kbanknew.png"} />
        )}

        <div className="text-xs ml-2 w-full">
          <div className="flex w-full justify-between text-gray-700">
            {/* <div className="tooltiptext">{item.installment_relate}</div> */}
            <div className=" w-32 h-4 overflow-auto ">
              {" "}
              <div>
                งวดที่ {item?.installment_relate} ({item?.priceType})
              </div>
            </div>
            {!openReverse ? (
              <div
                onClick={onClickOpenEvidenceDetail}
                className=" text-black cursor-pointer transition-colors duration-200 hover:opacity-7 mb-auto"
              >
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                  />
                </svg>
              </div>
            ) : (
              <button onClick={() => onClickSelectEvidence()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={classNames(
                    "h-5 w-5 cursor-pointer hover:text-green-500 transition-all duration-100",
                    {
                      "text-green-500": currentEvidenceIndex === index,
                      "text-gray-500": currentEvidenceIndex !== index,
                    }
                  )}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </button>
            )}
          </div>
          <div className="text-xs font-bold text-gray-700">
            {numeral(item.paidAmount).format("0,000.00")}
          </div>

          <div className="text-gray-500 font-thin">
            {format(new Date(item.paidDate), "dd-MM-yyyy HH:mm")}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-end">
        <React.Fragment>
          <div className="grid grid-cols-2 text-xs mt-2 gap-x-2">
            <div className={`${prePrincipleColor}`}>
              (เงินต้น):{" "}
              {numeral(item.evidencePaidPrinciple).format("0,000.00")}
            </div>
            {loan?.category === "TF" && (
              <div className={prePrincipleColor}>
                (ภาษี):{" "}
                {numeral(item.evidencePaidPrincipleVat).format("0,000.00")}
              </div>
            )}
            <div className={preOverflow}>
              (ล่วงหน้า):{" "}
              {numeral(item.evidencePaidPrincipleOverflow).format("0,000.00")}
            </div>
            {loan?.category === "TF" && (
              <div className={preOverflow}>
                (ภาษี):{" "}
                {numeral(item.evidencePaidPrincipleVatOverflow).format(
                  "0,000.00"
                )}
              </div>
            )}

            <div className={preInterestColor}>
              (ดอกเบี้ย):{" "}
              {numeral(item.evidencePaidInterest).format("0,000.00")}
            </div>
            {loan?.category === "TF" && (
              <div className={preInterestColor}>
                (ภาษี):{" "}
                {numeral(item.evidencePaidInterestVat).format("0,000.00")}
              </div>
            )}
            {loan?.category === "TF" && (
              <div className={preOverflow}>
                (ล่วงหน้า):{" "}
                {numeral(item.evidencePaidInterestOverflow).format("0,000.00")}
              </div>
            )}

            {loan?.category === "TF" && (
              <div className={preOverflow}>
                (ภาษี):{" "}
                {numeral(item.evidencePaidInterestVatOverflow).format(
                  "0,000.00"
                )}
              </div>
            )}

            <div className={preLateColor}>
              (ผิดนัด): {numeral(item.evidencePaidPenalty).format("0,000.00")}
            </div>
            <div className={preLateColor}>
              (ท่วงถาม):{" "}
              {numeral(item.evidencePaidDemandFee).format("0,000.00")}
            </div>
            {loan?.category === "TF" && (
              <div className={preLateColor}>
                (ลงพื้นที่):{" "}
                {numeral(item.evidencePaidVisitFee).format("0,000.00")}
              </div>
            )}
          </div>
          <div className="text-blue-500 text-xs mt-1">TX : {item.tx}</div>
        </React.Fragment>
      </div>
    </div>
  );
};

export default FootageEvidences;
